import { formatAmount } from '@echodex/utils/formatInfoNumbers'
import { V2_SUBGRAPH_URLS, V3_SUBGRAPH_URLS } from 'config/constants/endpoints'
import { useGetTvlQuery } from 'graphql/v2/generated/types-and-hooks'
import { useV3TvlQuery } from 'graphql/v3/generated/types-and-hooks'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { MainApiRoute, useMainApi } from 'hooks/useMainApi'
import { useMemo } from 'react'
import styled from 'styled-components'

const StyledCard = styled.div`
    border-radius: 12px;
    box-shadow: ${({ theme }) => theme.shadows.app};
    border: 1px solid ${({ theme }) => theme.colors.borderCard};
    background-color: ${({ theme }) => theme.colors.backgroundAlt};
`

export const ExchangeSummary = () => {
    const { chainId } = useActiveChainId()
    const { data: dataTVL } = useGetTvlQuery({ endpoint: V2_SUBGRAPH_URLS[chainId] })
    const { data: v3TVL } = useV3TvlQuery({ endpoint: V3_SUBGRAPH_URLS[chainId] })

    const tvl = useMemo(() => {
        if (!dataTVL || !v3TVL) return 0
        return parseInt(dataTVL?.echodexFactories[0].totalLiquidityUSD) + parseInt(v3TVL?.factories[0] ? v3TVL?.factories[0].totalValueLockedUSD : 0)
    }, [dataTVL, v3TVL])

    const totalVolume = useMemo(() => {
        if (!dataTVL || !v3TVL) return 0
        return parseInt(dataTVL?.echodexFactories[0].totalVolumeUSD) + parseInt(v3TVL?.factories[0] ? v3TVL?.factories[0].totalVolumeUSD : 0)
    }, [dataTVL, v3TVL])

    const totalTransactions = useMainApi(MainApiRoute.GET_TOTAL_TRANSACTIONS)

    return (
        <div className="inner ">
            <div className="grid gap-4 lg:gap-8 lg:grid-cols-3 ">
                <StyledCard className="px-6 py-4 lg:px-9">
                    <div className="text-sm text-gray1">TVL</div>
                    <div className="lg:text-[32px] text-gray2 mt-2">
                        ${formatAmount(tvl)}
                    </div>
                </StyledCard>
                <StyledCard className="px-6 py-4 lg:px-9">
                    <div className="text-sm text-gray1">Total Volume</div>
                    <div className="lg:text-[32px] text-gray2 mt-2">
                        ${formatAmount(totalVolume)}
                    </div>
                </StyledCard>
                <StyledCard className="px-6 py-4 lg:px-9">
                    <div className="text-sm text-gray1">Total Transactions</div>
                    <div className="lg:text-[32px] text-gray2 mt-2">{formatAmount(parseInt(totalTransactions), {notation: "standard", tokenPrecision: "zero"})}</div>
                </StyledCard>
            </div>
        </div>
    )
}

export default ExchangeSummary
